<template>
  <div class="fill-height">
    <AlertHistory :filter-open="false" :user-id="$store.getters.getUserId"/>
  </div>
</template>

<script>
import AlertHistory from "@/components/Alert/AlertHistory";

export default {
  name: "CircleHistory",
  components: {AlertHistory},
};
</script>

<style scoped>
</style>
